import type { Metadata } from "next";
import { NotificationsClient } from "./notifications-client";

export const metadata: Metadata = {
  title: "Notifications — Alqove",
};

export default function NotificationsPage() {
  return (
    <div className="mx-auto max-w-3xl px-4 py-8">
      <h1 className="text-2xl font-semibold text-forest mb-4">Notifications</h1>
      <NotificationsClient />
    </div>
  );
}
